<template>
    <div class="GreOrder">
        <!-- s: header -->
        <header id="header-slidePanel">
            <h2>그레 상품 주문하기</h2>
            <div class="btn_back">
                <a @click="slidePanelClose">
                    <img src="@/assets/images/btn_back.png" width="50" alt="이전" />
                </a>
            </div>
        </header>
        <!-- e: header -->
        <!-- s: contents -->
        <div class="contents-area-slidePanel">
            <div class="gre-expected">
                <div class="gre-expected-point">
                    <h3>사용가능 {{oGrePoint.setting.nGreTotalCount}} 그레</h3>
                </div>
                <p>상품을 선택해 주세요.</p>
            </div>
            <div class="mrg-top-15 mrg-btm-10 pdd-horizon-20" style="height: 380px">
                <mt-swipe :auto="4000">
                    <mt-swipe-item v-for="(data, index) in oGrePoint.product" :key="index">
                        <div :class="'bGreSoldout_'+data.bGreSoldout"  @click="funGreProduct(data)">
                            <a>
                                <img :src="data.strImageLink" width="100%" @load="imgLoad" style="max-height: 300px" />
                            </a>
                        </div>
                        <h6 class="mrg-top-10" style="font-size: 18px; color: #a4a4a4;">{{ data.strProductName }}</h6>
                        <h4 class="mrg-top-10" style="color: #0086ff; font-size: 18px;">{{ data.nGreSalePrice }}그레</h4>
                    </mt-swipe-item>
                </mt-swipe>
            </div>
        </div>
        <!-- e: contents -->
    </div>
</template>

<script>
export default {
    name: 'GreOrder',
    data() {
        return {
            oGrePoint: {
                "setting": {
                    "nGreProductCnt": 0,    // 판매 제품 개수
                    "nGreTotalCount": 0     // 사용 가능 그레
                },
                "product": []               // 제품정보
            }
        }
    },
    // 감시자
    watch: {
    },
    // $el 생성전
    created(){
        this.getGreProduct();
    },
    // $el 생성후
    mounted() {
        window.callbackBackKey = this.callbackBackKey;
    },
    methods: {
        // APP 뒤로가기
        callbackBackKey(){
            this.slidePanelClose();
        },
        // 그레 상품 정보
        getGreProduct(){
            let param = {};
            this.ajaxGetAuth('/api/v1/gre/product', param, this.getGreProductResult);
        },
        // 그레 상품 정보 결과
        getGreProductResult(response){
            if (response.result.code == 0){
                this.oGrePoint = response.oGrePoint;
            }else{
                this.toastMsg(response.result.resultNoti.message,1500);
            }
        },
        // 그레상품주문하기 Slide
        funGreProduct(data){
            if (data.bGreSoldout == 'N'){
                if (data.nGreSalePrice > this.oGrePoint.setting.nGreTotalCount){
                    this.toastMsg('그레가 부족하여 주문할 수 없습니다.',1500);
                }else{
                    this.greProductSlideView(data)
                }

            }else{
                this.toastMsg('상품이 품절되어 주문 할 수 없습니다.',1500);
            }
        },
        // 그레상품주문하기 Slide
        greProductSlideView(data){
            let props = {
                data : data,
            };
            const panel =this.$showPanel({
                component: () => import('@/views/slide/GreProduct.vue'),
                props: props,
                openOn: 'right',
                width:screen.width,
            });
            panel.promise.then(result => {
                window.callbackBackKey = this.callbackBackKey;
                if (result.result === "close"){
                    this.slidePanelClose(result);
                }
            });
        },
    }
}
</script>
<style scoped>
    .gre-expected {border-top: 1px solid #dfdfdf;border-bottom: 1px solid #dfdfdf;margin-top: 15px;padding: 20px 20px 20px 15px;}
    .gre-expected-point{flex: 1;display: flex;flex-direction: row;}
    .gre-expected-point h3{flex-basis: 150px;font-size: 15px;color: #000;line-height: 180%;}
    .gre-expected-point h4{flex: 1;text-align: right;color: #000;font-size: 18px;}
    .gre-expected p{color: #a4a4a4;}

    .gre-expected-date {border-top: 1px solid #dfdfdf;border-bottom: 1px solid #dfdfdf;padding: 10px 0px 10px 0px;}
    .gre-expected-point-date{flex: 1;display: flex;flex-direction: row;}
    .gre-expected-point-date h3{flex-basis: 80px;font-size: 15px;color: #000;line-height: 180%; text-align: left; padding-left: 10px}
    .gre-expected-point-date h4{flex: 1;text-align: right;color: #000;font-size: 15px;text-align: left;}
    .gre-expected-date p{color: #a4a4a4;}

    .mint-swipe-items-wrap > div {text-align: center;}

    .bGreSoldout_Y {position: relative}
    .bGreSoldout_Y:before {content: "";position: absolute;left: 0;right: 0;top: 0;bottom: 0;background-color: rgba(0,0,0,.4);border-radius: 10px;}
    .bGreSoldout_Y:after {content: "품절";position: absolute;font-size: 34px;position:absolute; left:50%; top:50%;transform: translate(-50%,-50%);color:#fff;}

    .bGreSoldout_Y a{}

</style>
